import { Card, CardContent, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface AIFunctionCardProps {
  aiFunction: any;
}
export const AIFunctionCard = ({ aiFunction }: AIFunctionCardProps) => {
  const navigate = useNavigate();
  return (
    <Card>
      <CardContent>
        <h5
          className="cursor-pointer"
          onClick={() => navigate(`/admin/ai-agents/${aiFunction.agentID}/functions/edit/${aiFunction.id}`)}
        >
          {aiFunction.name}
        </h5>
        <Typography variant="body1">{aiFunction.description}</Typography>
      </CardContent>
    </Card>
  );
};
